<template>
  <div class="container license-list">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group input-group table-actions__input">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i
                class="fa fa-search"
                aria-hidden="true"
              />
            </div>
          </div>
          <datalist id="select-order-id">
            <option
              v-for="(words, i) in filterItemList.orderNumber"
              :key="i"
              :value="words"
            />
          </datalist>
          <input
            type="text"
            class="form-control text-autocomplete"
            v-model="orderIdFilter"
            id="select-order-id"
            autocomplete="on"
            list="select-order-id"
            :placeholder="$t('AdminManagement.LicenseTable.OrderNumberSelector')"
          >
          <template v-if="pageType === 'adminSetting'">
            <datalist id="select-customer-id">
              <option
                v-for="(words, i) in filterItemList.customerId"
                :key="i"
                :value="words"
              />
            </datalist>
            <input
              type="text"
              class="form-control text-autocomplete"
              v-model="customerIdFilter"
              id="select-customer-id"
              autocomplete="on"
              list="select-customer-id"
              :placeholder="$t('AdminManagement.LicenseTable.CustomerIdSelector')"
            >
          </template>
          <datalist id="search-words">
            <option
              v-for="(words, i) in filterItemList.wordList"
              :key="i"
              :value="words"
            />
          </datalist>
          <input
            type="text"
            class="form-control text-autocomplete"
            v-model="filterWords"
            id="search-words"
            autocomplete="on"
            list="search-words"
            :placeholder="$t('Setting.UserTable.SearchInputPlaceholder')"
          >
        </div>
      </div>
    </div>
    <table class="table">
      <!-- NOTE: HEADER -->
      <thead>
        <tr>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.purchaseDate === 'asc',
                'table-sort-down': sortObj.purchaseDate === 'desc'
              }"
              @click="changeSortType('purchaseDate')"
            >
              {{ $t("AdminManagement.LicenseTable.PurchaseDate") }}
            </button>
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.orderNumber === 'asc',
                'table-sort-down': sortObj.orderNumber === 'desc'
              }"
              @click="changeSortType('orderNumber')"
            >
              {{ $t("AdminManagement.LicenseTable.OrderNumber") }}
            </button>
          </th>
          <th
            scope="col"
            v-if="pageType === 'adminSetting'"
          >
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.customerId === 'asc',
                'table-sort-down': sortObj.customerId === 'desc'
              }"
              @click="changeSortType('customerId')"
            >
              {{ $t("AdminManagement.LicenseTable.CustomerId") }}
            </button>
          </th>
          <th
            scope="col"
            v-if="pageType === 'adminSetting'"
          >
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.customerName === 'asc',
                'table-sort-down': sortObj.customerName === 'desc'
              }"
              @click="changeSortType('customerName')"
            >
              {{ $t("AdminManagement.LicenseTable.CustomerName") }}
            </button>
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.licenseType === 'asc',
                'table-sort-down': sortObj.licenseType === 'desc'
              }"
              @click="changeSortType('licenseType')"
            >
              {{ $t("AdminManagement.LicenseTable.LicenseType") }}
            </button>
          </th>
          <th
            scope="col"
            v-if="pageType === 'adminSetting'"
          >
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.purchaseType === 'asc',
                'table-sort-down': sortObj.purchaseType === 'desc'
              }"
              @click="changeSortType('purchaseType')"
            >
              {{ $t("AdminManagement.LicenseTable.PurchaseType") }}
            </button>
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.inUseNumber === 'asc',
                'table-sort-down': sortObj.inUseNumber === 'desc'
              }"
              @click="changeSortType('inUseNumber')"
            >
              {{ $t("AdminManagement.LicenseTable.InUseNumber") }}
            </button>
          </th>
          <th scope="col">
            /
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.purchasedNumber === 'asc',
                'table-sort-down': sortObj.purchasedNumber === 'desc'
              }"
              @click="changeSortType('purchasedNumber')"
            >
              {{ $t("AdminManagement.LicenseTable.PurchasedNumber") }}
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in filterdItems"
          :key="item.key"
        >
          <td class="table-center">
            {{ $d(item.paymentDate, 'yymmdd_hhmmss') }}
          </td>
          <td class="table-right">
            {{ item.orderId }}
          </td>
          <td
            class="table-right"
            v-if="pageType === 'adminSetting'"
          >
            {{ item.customerId }}
          </td>
          <td
            class="table-right"
            v-if="pageType === 'adminSetting'"
          >
            {{ item.customerName }}
          </td>
          <td class="table-right">
            {{ item.licenseTypeName }}
          </td>
          <td
            class="table-right"
            v-if="pageType === 'adminSetting'"
          >
            {{ item.purchaseTypeName }}
          </td>
          <td class="table-right">
            {{ item.numberOfUsingLicense }}
          </td>
          <td class="table-center">
            /
          </td>
          <td class="table-right">
            {{ item.numberOfLicense }}
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="table-empty"
      v-if="!filterdItems.length"
    >
      <div class="table-empty-label">
        {{ $t("General.NoData") }}
      </div>
    </div>

    <!-- NOTE: pagenatino -->
    <nav
      class="pagination"
      v-else
    >
      <p>
        {{ `${pagenationCount.start} - ${pagenationCount.end} of ${pagenationCount.all}` }}
      </p>
      <VSelectbox
        class="pagenation-step"
        :items="stepArray"
        select-id="select-step"
        size="sm"
        @selectedData="pageStep = $event"
      />
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.start <= 1}"
          @click="subPagenationIndex"
        >
          <i class="fas fa-chevron-left" />
        </button>
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.end >= pagenationCount.all}"
          @click="addPagenationIndex"
        >
          <i class="fas fa-chevron-right" />
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import VSelectbox from '@/components/VSelectbox'
import { mapState } from 'vuex'
export default {
  components: {
    VSelectbox
  },
  props: {
    pageType: {
      type: String,
      default: 'setting'
    }
  },
  data: () => ({
    sortObj: {
      purchaseDate: false,
      orderNumber: false,
      customerId: false,
      customerName: false,
      licenseType: false,
      purchaseType: false,
      purchasedNumber: false,
      inUseNumber: false
    },
    filterWords: '',
    orderIdFilter: null,
    customerIdFilter: null,
    pageIndex: 0,
    pageStep: 10,
  }),
  computed: {
    ...mapState('auth', [
      'licenseList'
    ]),
    items() {
      if (!this.licenseList.length) return []
      return [].concat(this.licenseList).map((arr) => {
        return Object.assign({...arr}, {
          paymentDate: new Date(arr.paymentDate),
          licenseTypeName: this.$t(`AdminManagement.License.${arr.licenseType}`),
          purchaseTypeName: this.$t(`AdminManagement.Purchase.${arr.purchaseType}`),
        })
      })
    },
    filterdItems() {
      return [].concat(this.items).filter((arr) => {
        if (!this.filterWords) return true
        const words = `${arr.paymentDate}_${arr.customerName}_${arr.licenseTypeName}_${arr.purchaseTypeName}`
        return words.includes(this.filterWords)
      }).filter((arr) => {
        if (!this.orderIdFilter) return true
        return String(arr.orderId).includes(this.orderIdFilter)
      }).filter((arr) => {
        if (!this.customerIdFilter) return true
        return String(arr.customerId).includes(this.customerIdFilter)
      }).sort((a, b) => {
        if (!this.sortObj.purchaseDate) return true
        return this.sort(a.paymentDate, b.paymentDate, this.sortObj.purchaseDate === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.orderNumber) return true
        return this.sort(a.orderId, b.orderId, this.sortObj.orderNumber === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.customerId) return true
        return this.sort(a.customerId, b.customerId, this.sortObj.customerId === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.customerName) return true
        return this.sort(a.customerName, b.customerName, this.sortObj.customerName === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.licenseType) return true
        return this.sort(a.licenseType, b.licenseType, this.sortObj.licenseType === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.purchaseType) return true
        return this.sort(a.purchaseType, b.purchaseType, this.sortObj.purchaseType === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.purchasedNumber) return true
        return this.sort(a.numberOfLicense, b.numberOfLicense, this.sortObj.purchasedNumber === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.inUseNumber) return true
        return this.sort(a.numberOfUsingLicense, b.numberOfUsingLicense, this.sortObj.inUseNumber === 'asc')
      }).slice(this.pagenationCount.start - 1, this.pagenationCount.end)
    },
    filterItemList() {
      if (!this.items.length) return []
      const result = [].concat(this.items).reduce((acc, cur) => {
        if (!acc.purchaseDate.includes(this.$d(cur.paymentDate, 'yymmdd'))) acc.purchaseDate.push(this.$d(cur.paymentDate, 'yymmdd'))
        if (!acc.customerName.includes(cur.customerName)) acc.customerName.push(cur.customerName)
        if (!acc.licenseType.includes(cur.licenseTypeName)) acc.licenseType.push(cur.licenseTypeName)
        if (!acc.purchaseType.includes(cur.purchaseTypeName)) acc.purchaseType.push(cur.purchaseTypeName)
        if (!acc.orderNumber.includes(cur.orderId)) acc.orderNumber.push(cur.orderId)
        if (!acc.customerId.includes(cur.customerId)) acc.customerId.push(cur.customerId)
        return acc
      }, {
        purchaseDate: [],
        customerName: [],
        licenseType: [],
        purchaseType: [],
        orderNumber: [],
        customerId: []
      })
      return {
        wordList: [
          ...result.purchaseDate,
          ...result.customerName,
          ...result.licenseType,
          ...result.purchaseType,
        ],
        orderNumber: result.orderNumber,
        customerId: result.customerId,
      }
    },
    orderNumberSelectItem() {
      if (!this.filterItemList.orderNumber || !this.filterItemList.orderNumber.length) return []
      return [].concat(this.filterItemList.orderNumber).map((v) => ({
        text: v,
        value: v,
        selected: v === this.orderIdFilter
      }))
    },
    customerIdSelectItem() {
      if (!this.filterItemList.customerId || !this.filterItemList.customerId.length) return []
      return [].concat(this.filterItemList.customerId).map((v) => ({
        text: v,
        value: v,
        selected: v === this.customerIdFilter
      }))
    },
    pagenationCount() {
      if (!Array.isArray(this.licenseList)) return { all: 0, start: 0, end: 0 }
      const all = this.licenseList.length
      const start = (this.pageStep * this.pageIndex) + 1
      const end = (this.pageStep * (this.pageIndex + 1))
      return {
        all,
        start,
        end: (end < all) ? end : all
      }
    },
    stepArray() {
      return [5, 10, 25, 50, 100].map((arr) => ({
        text: arr,
        value: arr,
        selected: this.pageStep === arr
      }))
    },
  },
  methods: {
    changeSortType(target) {
      if (!this.sortObj[target]) {
        this.$set(this.sortObj, target, 'asc')
      } else if (this.sortObj[target] === 'asc') {
        this.$set(this.sortObj, target, 'desc')
      } else {
        this.$set(this.sortObj, target, false)
      }
    },
    sort(a, b, isAsc) {
      if (typeof a == 'string' || a instanceof String) {
        if (isAsc) return (a < b) ? -1 : 1
        return (a < b) ? 1 :-1
      }
      if (isAsc) return b - a
      return a - b
    },
    subPagenationIndex() {
      if (this.pagenationCount.start <= 1) return false
      this.pageIndex -= 1
    },
    addPagenationIndex() {
      if (this.pagenationCount.end >= this.pagenationCount.all) return false
      this.pageIndex += 1
    },
  }
}
</script>

<style lang="scss" scoped>
.license-list {
  font-size: 1rem;
}
</style>
